import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Are your sales people are competent?" />

      <nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/&amp;title=Are%20your%20sales%20people%20are%20competent%3F&amp;summary=Are%20your%20sales%20people%20are%20competent%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Are%20your%20sales%20people%20are%20competent%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Are%20your%20sales%20people%20are%20competent%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-top-cloud.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Are your sales people are competent?</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>23 February 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Are you assessing the right things?</h3>
<p>I was fortunate enough to spend some time recently discussing sales competencies and effectiveness with the affable Mr John Dougan. John is the VP of Global Sales at Profiling Online, and is recognised as one of the world’s leading authorities in sales effectiveness. John has authored sales performance content for LinkedIn, Reuters, Salesforce, Nitro, Sales4Life and MHI Global where he is commonly referred to as ‘The Intrepid Sales Detective’.</p>
<div className="rich-text"><p>During my discussion with John, he made some very interesting points:</p><p><strong>1 - Sales people (and their managers) are often completely unaware of why their sales performance is diminishing and most have not identified the actual variables that require improvement: </strong>According to the <a href="https://www.csoinsights.com/getattachment/Blog/June-2015/Insights-from-the-Sales-Management-Optimization-Re/2015-Sales-Management-Optimization-Key-Trends-Analysis.pdf.aspx">CSO Insights 2015 Sales Compensation and Performance Management Study</a>, only 54.6% of sales professionals meet quota, meaning 45.4% do not. This leaves us with the question, "Are salespeople not reaching their goals because of a lack of professional capabilities? These statistics, along with other industry research reveals that as a function, B2B sales forces are becoming increasingly inefficient. And yet, most respond with that tired old knee jerk of “lets get someone in to do some sales training".</p><p><strong>2 - Investment without the thorough understanding of what problem is being addressed</strong>: sales enablement is a huge area of investment for many organisations right now and Johns’ concern is that many initiatives are undertaken without understanding the current state of the sales culture.</p><p><em>“Without first undertaking a thorough diagnostic or capability assessment, how do you know what to focus on changing if you are to stem the flow of sub-par sales performance. In particular, what should be your initial focus to drive ROI in the short term?”</em></p><p>Everyone now knows that the buying landscape is changing, yet we as sellers have often relied on the same consistent approach for many, many years. Do we actually know what makes a sales person successful in today’s global, digital connected economy? This discussion led to the following question:</p><p><strong>Are the skills and behaviours of your high performers consistent or are there a multitude of contributors to their individual success? </strong>To answer this, John believes that each unique organisation needs to consider looking at a range of skills which contribute to sales success. This range can be grouped into 4 key principles:</p><ol><li><strong>Engaging</strong></li><li><strong>Enlightening</strong></li><li><strong>Energizing</strong></li><li><strong>Efficacy</strong></li></ol><p>Successful sales and service is delivered through <strong>‘engaging’</strong> each customer or prospect, <strong>‘enlightening’ </strong>them on how you can help solve their problem or recognize opportunity and <strong>‘energizing’ </strong>them to take commercial action. Taking this type of approach and considering the skills and activities required at each step results in a final stage; <strong>‘efficacy’ </strong>which is inclusive of many of the operational capabilities required to be successful. These principles should make us consider both the human elements of successful selling, the behaviours that reflect them, and the core activities and skills that are needed to execute them. Surely this is what we should be assessing?</p><p>So, if your current framework for assessing sales capability isn’t considering the emotions, feelings and beliefs that impact performance then, as a leader, you’re failing your sales people. If you are not considering these type of results, then it’s not a true assessment of actual capability.</p><p>Many of the most commonly reported sales challenges are based on organisational frustrations around process but that doesn’t tell us why salespeople are not succeeding. Having and owning a process is a key component, but it’s important that to understand key individual attributes alongside company or group failings. <a href="http://www.profilingonline.com/blog/how-to-gain-meaningful-insights-with-effective-capability-assessment-reporting">For reporting to be truly valuable in measuring the ROI of training</a>, it should cover both group level based organisational issues as well as the individual need for development in core sales competencies.</p><p>Of course, in among all of this, we also need to consider the rapidly evolving state of the sales role, if we are to glean meaningful insight into <a href="http://www.profilingonline.com/blog/football-field-to-the-boardroom-lessons-on-leadership-development">development of individuals or group training</a>. This means looking at other functional capability that sit outside of core selling activities. For example, as the line between sales and marketing blurs, what new marketing competencies do your sales people now require to effectively engage customers earlier in their buying cycle, energizing them to take action and enlightening them on how your sales department can help?</p><p>Similarly, if we value an employee but their <em>efficacy</em> is below par, how do we transition them into another, more suitable area of our organisation, assuming that is a real option. The bottom line is, there will be vast numbers of sales people that will need to transition their careers in the coming years, and this journey must begin with a frank, authentic and extensive diagnostic  or assessment of capability that extends well beyond the sales person’s ability to follow a sales process.</p><p>In summary, John Dougan believes that we must consider:</p><ul><li>Why are the top sellers in your organisation successful?</li><li>How do they achieve success? What skills to they possess that others don't?</li><li>What do they do consistently that makes them successful?</li><li>Are the frameworks that you use to measure sales efficacy outdated?</li></ul><p>Put simply, you can't prescribe a remedy if you haven't properly diagnosed the problem.</p><p>If you would like to know more about how a capability framework and associated sales assessments would help your organisation, please feel free to contact <a href="http://bit.ly/2b61u7h">John Dougan </a>at <a href="http://bit.ly/2bkmjuU">Profiling Online. </a></p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/&amp;title=Are%20your%20sales%20people%20are%20competent%3F&amp;summary=Are%20your%20sales%20people%20are%20competent%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Are%20your%20sales%20people%20are%20competent%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Are%20your%20sales%20people%20are%20competent%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/are-your-sales-people-are-competent/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 